import { Component, OnInit, ViewChild } from '@angular/core';
import { CompanyService } from 'app/company/services/company.service';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { Location } from '@angular/common';
import { CompanyAuditDetailsModel } from 'app/company/models/company-audit-details.model';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditListModel } from 'app/audit/models/audit-list.model';

@Component({
    templateUrl: './company-audit-details.component.html',
    styleUrls: ['./company-audit-details.component.css']
})
export class CompanyAuditDetailsComponent implements OnInit {
    companyAuditDetailsModel: CompanyAuditDetailsModel;
    errors: string[];
    headerTitle: IHeaderTitle;
    submitAttempt = false;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    redirectRoutes: Routes;
    companyAuditDetailsFormGroup: FormGroup;
    isEditMode = false;
    companyId: string;
    auditId: string;
    audits: AuditListModel[];

    constructor(
        private companyService: CompanyService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private auditService: AuditService,
		private location: Location,
        private router: Router
    ) { }

    ngOnInit() {
        this.load();
        this.getAudits();
    }

    getAudits(): void {
        this.auditService.getAll().subscribe(
            audits => {
                this.audits = audits;
            },
            error => this.errors = error.errorList
        );
    }

    load(): void {
        this.companyId = this.activatedRoute.snapshot.params['companyId'];
        this.auditId = this.activatedRoute.snapshot.params['auditId'];
        this.companyService.getCompanyAudit(this.auditId).subscribe(companyAuditDetailsModel => {
            this.companyAuditDetailsModel = companyAuditDetailsModel;
            this.companyAuditDetailsModel.startDate = this.companyAuditDetailsModel.startDate ? new Date(this.companyAuditDetailsModel.startDate) : null;
            this.companyAuditDetailsModel.endDate = this.companyAuditDetailsModel.endDate ? new Date(this.companyAuditDetailsModel.endDate) : null;
            this.initializeForm(companyAuditDetailsModel);
            this.headerTitle = {
                title: companyAuditDetailsModel.title,
                breadcrumbs: [{ title: 'Company Audits', url: ['/company/audits', this.companyId] }]
            };
        });
    }

    initializeForm(model: CompanyAuditDetailsModel): void {
        this.companyAuditDetailsFormGroup = this.fb.group(
            {
                id: [this.auditId],
                title: [model.title, Validators.required],
                auditId: [model.auditId],
                audit: [model.audit],
                startDate: [model.startDate, Validators.required],
                endDate: [model.endDate]
            }
        );
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    updateCompanyAudit(): void {
        this.submitAttempt = true;

        var startDate = this.companyAuditDetailsFormGroup.get('startDate').value;
        var endDate = this.companyAuditDetailsFormGroup.get('endDate').value;
        
        if (this.companyAuditDetailsFormGroup.valid) {
            const formValue = this.companyAuditDetailsFormGroup.value;
            formValue.startDate = startDate ? new Date(new Date(startDate).setHours(12)).toISOString() : null;
            formValue.endDate = endDate ? new Date(new Date(endDate).setHours(12)).toISOString() : null;

            this.companyService.updateCompanyAudit(formValue).subscribe(
                response => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        }
    }

    successClicked($event: any): void {
        this.router.navigate(['/company/audits', this.companyId]);
    }

    onHide($event: any): void { }

    onBack(): void {
        this.location.back();
    }
}
